export default __webpack_public_path__ + "img/ee237e3f05523784328c5ef7c458b227.svg";